var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_199_604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5859 5.62401V14.374",
    stroke: "white",
    strokeWidth: 0.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.21289 9.99901H14.9629",
    stroke: "white",
    strokeWidth: 0.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.1952C1 15.2652 5.12478 19.39 10.1948 19.39C15.2649 19.39 19.3896 15.2652 19.3896 10.1952C19.3896 5.12514 15.2649 1.00036 10.1948 1.00036C5.12478 1.00036 1 5.12514 1 10.1952ZM0 10.1952C0 4.56473 4.56437 0.000358582 10.1948 0.000358582C15.8253 0.000358582 20.3896 4.56473 20.3896 10.1952C20.3896 15.8256 15.8253 20.39 10.1948 20.39C4.56437 20.39 0 15.8256 0 10.1952Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_199_604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(3.08594 2.49901)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.176ef29bff4220c9f376ae5c2784bb47.svg";
export { ForwardRef as ReactComponent };